import React, { useState } from 'react'
import { Button } from 'components/ui'
import { FileText } from 'lucide-react'
import useLocaleText from 'components/useLocaleText'
import { BaseModalV3 } from 'components/ui/BaseModal'
import { TaskPublishingOverlay } from 'components/CommonComponents/TaskPublishingOverlay'
import TaskSettingStep from 'components/TasksV2/TaskCreation/Steps/TaskSettingStep'
import { useFormStepContext } from 'components/TasksV2/TaskCreation/FormStepContext'
import { Header } from 'components/TasksV2/TaskCreation/TaskCreationModal/Header'
import 'components/TasksV2/TaskCreation/TaskCreationModal/styles.css'
import { IContentFormData, PageStep } from '../../types'
import { CategoryContentStep } from '../CategoryContentStep'

export function CategoryTaskPage({
  step,
  content,
  onNext,
  onBack,
  onClose,
  onRequestClose,
}: {
  step: PageStep
  content?: IContentFormData
  onNext: (data: IContentFormData) => void
  onBack: () => void
  onClose: () => void
  onRequestClose: () => void
}) {
  const [headerSlot, setHeaderSlot] = useState<HTMLDivElement | null>(null)
  const { publicationComplete, isSubmitting, isMediaUploading, isSubtaskAiGenerating, isPdfGenerating, generatePdf } =
    useFormStepContext()
  const pdf = useLocaleText('export_to_pdf')
  const busy = isSubmitting || isMediaUploading || isSubtaskAiGenerating

  return (
    <BaseModalV3
      floating
      isOpen
      onClose={busy ? () => {} : onRequestClose}
      contentProps={{ className: 'creation-dual-modal' }}
      scrollMemoryKey={String(step)}
      header={
        <Header
          navigationDisabled={!!busy}
          extraActions={
            step === 1 ? (
              <Button
                type="button"
                variant="icon"
                aria-label={pdf}
                title={pdf}
                isDisabled={!!busy || isPdfGenerating}
                onClick={generatePdf}
              >
                <FileText size={17} />
              </Button>
            ) : undefined
          }
          builder={step === 0}
          settings={step === 1}
          onBack={onBack}
          onClose={onClose}
          titleSlotRef={setHeaderSlot}
        />
      }
      body={
        isSubmitting ? (
          <TaskPublishingOverlay complete={publicationComplete} />
        ) : step === 0 ? (
          <CategoryContentStep initialData={content} onNext={onNext} headerSlot={headerSlot} />
        ) : (
          <TaskSettingStep dualView headerSlot={headerSlot} />
        )
      }
      footer={null}
      footerProps={{ style: { display: 'none' } }}
    />
  )
}
